// Mock data for Brand Name trademark company website

export const companyInfo = {
  name: "Trademark Frontline",
  tagline: "Your Trusted Partner in Brand Protection",
  phone: "+1 (844) 627 0636",
  email: "info@trademarkfrontline.com",
  address: "515 Flower St, Los Angeles, CA 90071, USA"
};

export const stats = {
  approvalRate: "98%",
  support: "24/7",
  trademarksFiled: "10,000+",
  statesCovered: "50+"
};

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    slug: "trademark-registration",
    description: "Experience the fastest and easiest process for securing your trademark rights in the USA.",
    icon: "trademark",
    image: "https://images.unsplash.com/photo-1648337564744-f919c7c2fc02",
    fullDescription: "Protect your brand's unique identity with our comprehensive trademark registration service. We handle everything from initial search to final approval, ensuring your brand name, logo, or slogan receives the legal protection it deserves.",
    howWeWork: {
      description: "Our streamlined process makes trademark registration simple and stress-free. We handle all the complexities while keeping you informed every step of the way.",
      steps: [
        {
          title: "Information Collection",
          description: "Submit your brand details through our secure form. We'll gather all necessary information about your trademark."
        },
        {
          title: "Research and Search Report",
          description: "Our experts conduct comprehensive searches to ensure your mark is available and advise on the best filing strategy."
        },
        {
          title: "Application and Submission",
          description: "We prepare and file your application with the USPTO, monitoring it through approval and handling any office actions."
        }
      ]
    },
    whyChooseUs: [
      {
        title: "Expert Legal Team",
        description: "Our experienced trademark attorneys and specialists have successfully registered thousands of trademarks across all industries."
      },
      {
        title: "Comprehensive Search",
        description: "We conduct thorough federal and state searches to minimize rejection risks and identify potential conflicts before filing."
      },
      {
        title: "Fast Processing",
        description: "Our efficient system ensures quick turnaround times without compromising accuracy or attention to detail."
      },
      {
        title: "Ongoing Support",
        description: "From filing to approval and beyond, we provide continuous support including office action responses and renewal reminders."
      }
    ]
  },
  {
    id: 2,
    title: "Copyright Registration",
    slug: "copyright-registration",
    description: "Protect your original work — from books and music to digital content — with our seamless online copyright registration services.",
    icon: "copyright",
    image: "https://images.unsplash.com/photo-1593444285553-28163240e3f1",
    fullDescription: "Secure legal protection for your creative works with our professional copyright registration service. Whether you've created literary works, music, art, software, or digital content, we ensure your intellectual property rights are properly protected.",
    howWeWork: {
      description: "Our copyright registration process is designed for creators who value their work and want hassle-free legal protection.",
      steps: [
        {
          title: "Information Collection",
          description: "Provide details about your creative work and upload necessary files through our secure platform."
        },
        {
          title: "Research and Search Report",
          description: "We review your work for registrability and advise on the most appropriate registration type."
        },
        {
          title: "Application and Submission",
          description: "We file your copyright application with the U.S. Copyright Office and track it through completion."
        }
      ]
    },
    whyChooseUs: [
      {
        title: "All Content Types",
        description: "We handle copyright registration for books, music, art, photography, software, websites, and all forms of creative work."
      },
      {
        title: "Legal Expertise",
        description: "Our team understands copyright law intricacies and ensures your registration is filed correctly the first time."
      },
      {
        title: "Quick Turnaround",
        description: "We expedite the registration process while maintaining accuracy and compliance with Copyright Office requirements."
      },
      {
        title: "Certificate Delivery",
        description: "Receive your official copyright registration certificate with complete documentation for your records."
      }
    ]
  },
  {
    id: 3,
    title: "Company Formation",
    slug: "company-formation",
    description: "Ready to go global? Let us help you form your company in the U.S. with full legal compliance and business setup support.",
    icon: "building",
    image: "https://images.unsplash.com/photo-1702047149248-a6049168d2a8",
    fullDescription: "Start your business journey with confidence. Our company formation service handles all legal requirements to establish your LLC, Corporation, or other business entity in the United States with full compliance.",
    howWeWork: {
      description: "We simplify business formation with a proven three-step process that gets your company legally established quickly.",
      steps: [
        {
          title: "Information Collection",
          description: "Share your business details, choose your entity type, and select your state of incorporation."
        },
        {
          title: "Research and Search Report",
          description: "We verify name availability, check compliance requirements, and advise on the best structure for your needs."
        },
        {
          title: "Application and Submission",
          description: "We file all necessary documents with state authorities and obtain your EIN, ensuring your business is fully operational."
        }
      ]
    },
    whyChooseUs: [
      {
        title: "Full Service Setup",
        description: "We handle everything from name reservation to EIN acquisition, registered agent service, and compliance filings."
      },
      {
        title: "All Entity Types",
        description: "Whether you need an LLC, Corporation, Partnership, or Non-Profit, we have the expertise to form it correctly."
      },
      {
        title: "50-State Coverage",
        description: "Form your business in any U.S. state with our comprehensive knowledge of state-specific requirements."
      },
      {
        title: "Ongoing Compliance",
        description: "Stay compliant with annual reports, franchise tax filings, and registered agent services included in our packages."
      }
    ]
  },
  {
    id: 4,
    title: "Trademark Search",
    slug: "trademark-search",
    description: "We conduct detailed searches to ensure your brand name or logo is available and legally safe to use, avoiding future conflicts.",
    icon: "search",
    image: "https://images.unsplash.com/photo-1752697589092-e51006f84946",
    fullDescription: "Before investing in your brand, make sure it's available. Our comprehensive trademark search service identifies potential conflicts and provides detailed analysis to help you make informed decisions about your brand.",
    howWeWork: {
      description: "Our thorough search process examines multiple databases to uncover any potential conflicts before you invest in your brand.",
      steps: [
        {
          title: "Information Collection",
          description: "Tell us about your proposed trademark, including the name, logo, and the goods/services you'll offer."
        },
        {
          title: "Research and Search Report",
          description: "We conduct comprehensive searches across federal, state, and common law databases to identify conflicts."
        },
        {
          title: "Application and Submission",
          description: "Receive a detailed report with our professional analysis and recommendations for proceeding with registration."
        }
      ]
    },
    whyChooseUs: [
      {
        title: "Comprehensive Database Search",
        description: "We search USPTO records, state registrations, common law sources, and domain names for thorough conflict analysis."
      },
      {
        title: "Expert Analysis",
        description: "Beyond just searching, we provide professional interpretation of results and advice on registration likelihood."
      },
      {
        title: "Quick Results",
        description: "Get your detailed search report within 24-48 hours so you can move forward with confidence."
      },
      {
        title: "Risk Assessment",
        description: "We categorize potential conflicts by risk level and provide clear guidance on how to proceed safely."
      }
    ]
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    slug: "amazon-brand-registry",
    description: "Shield your Amazon store from counterfeiters and boost brand with trusted Amazon Brand Registry assistance.",
    icon: "shield",
    image: "https://images.unsplash.com/photo-1586880244406-556ebe35f282",
    fullDescription: "Protect your products and enhance your presence on Amazon with Brand Registry enrollment. Gain access to powerful tools that help you control your product listings, prevent counterfeiting, and build customer trust.",
    howWeWork: {
      description: "We guide you through Amazon's Brand Registry requirements and handle the entire enrollment process for hassle-free approval.",
      steps: [
        {
          title: "Information Collection",
          description: "Gather your trademark details, Amazon seller information, and product catalog data."
        },
        {
          title: "Research and Search Report",
          description: "We verify your trademark status and ensure you meet all Amazon Brand Registry eligibility requirements."
        },
        {
          title: "Application and Submission",
          description: "We complete and submit your Brand Registry application, liaising with Amazon to secure your approval."
        }
      ]
    },
    whyChooseUs: [
      {
        title: "Trademark Integration",
        description: "We can handle both your trademark registration and Amazon Brand Registry enrollment as a seamless package."
      },
      {
        title: "Fast Approval",
        description: "Our experience with Amazon's requirements means we get it right the first time, avoiding delays."
      },
      {
        title: "Complete Support",
        description: "From initial setup to ongoing brand protection tools, we help you maximize your Brand Registry benefits."
      },
      {
        title: "Counterfeit Prevention",
        description: "Learn how to use Amazon's tools to monitor and report unauthorized sellers and protect your brand reputation."
      }
    ]
  }
];

export const pricingPackages = {
  "trademark-registration": [
    {
      name: "Basic",
      price: 45,
      description: "",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "State E-Filing",
        "Trademark Secured",
        "*(Govt. filing fee not included)"
      ]
    },
    {
      name: "Deluxe",
      price: 145,
      description: "",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "State E-Filing",
        "Trademark Secured",
        "Direct Hit Search",
        "Dedicated Case Manager",
        "*(Govt. filing fee not included)"
      ],
      popular: true
    },
    {
      name: "Premium",
      price: 299,
      description: "",
      features: [
        "Case Review (by a TM Expert)",
        "Basic Free Trademark Search",
        "Trademark Monitoring Services (3 Months)",
        "Trademark Secured",
        "Refusal Risk Meter",
        "Case filing service with complete paperwork",
        "*(Govt. filing fee not included)"
      ]
    },
    {
      name: "Elite",
      price: 599,
      description: "",
      features: [
        "Case Review & Filing (U.S Registered IP Attorney)",
        "Assigned Case Filing Officer",
        "Private Registration",
        "Trademark Secured",
        "Federal Search & Clearance Report (All States)",
        "Federal E-Filing (USPTO)",
        "Cease & Desist Letter",
        "Same Day Filing",
        "Trademark Monitoring (1 Year)",
        "Trademark Secured",
        "Direct Hit Search",
        "Dedicated Case Manager",
        "24/7 Secure Online Access",
        "100% Approval Guarantee",
        "*(Govt. filing fee not included)"
      ]
    }
  ],
  "copyright-registration": [
    {
      name: "GOLD",
      price: 99,
      description: "+ USPTO Filing Fee",
      features: [
        "Professional Preparation of your federal copyright application including a review by the copyright team for accuracy, completeness and common mistakes",
        "Federal E-Filing - Electronic filing of your application with the USPTO with no need to wait for mail or dealing with paper files",
        "Certificate of Registration that will be mailed to you directly from the U.S. Copyright Office"
      ]
    },
    {
      name: "Diamond",
      price: 149,
      description: "+ USPTO Filing Fee",
      features: [
        "Cease & Desist Letter - A customer-specific form you can further customize if someone is infringing on your copyright. Avoid wasting time and money",
        "Transfer/Assignment - Custom assignment template. If you need to sell or otherwise convey your copyright, you have access to your pre-filled in template that you can further customize",
        "24 Hours Expedited Process of the preparation of your copyright application. Normal processing time is 5 business days in our Basic package"
      ],
      popular: true
    }
  ],
  "company-formation": [
    {
      name: "Starter",
      price: 149,
      originalPrice: 249,
      description: "Basic business formation for new entrepreneurs.",
      features: [
        "Name Availability Check",
        "Articles of Organization/Incorporation",
        "EIN Application",
        "Operating Agreement/Bylaws",
        "Basic Compliance Guide",
        "*(State filing fees not included)"
      ]
    },
    {
      name: "Professional",
      price: 299,
      originalPrice: 599,
      description: "Complete formation with registered agent service included.",
      features: [
        "Name Availability Check",
        "Articles of Organization/Incorporation",
        "EIN Application",
        "Operating Agreement/Bylaws",
        "Registered Agent Service (1 Year)",
        "Business License Research",
        "Compliance Calendar",
        "Dedicated Support",
        "*(State filing fees not included)"
      ],
      popular: true
    },
    {
      name: "Enterprise",
      price: 499,
      originalPrice: 599,
      description: "Full-service formation with ongoing compliance management.",
      features: [
        "Name Availability Check",
        "Articles of Organization/Incorporation",
        "EIN Application",
        "Operating Agreement/Bylaws",
        "Registered Agent Service (1 Year)",
        "Business License Research",
        "Compliance Calendar",
        "Annual Report Filing",
        "Amendment Services",
        "Corporate Records Maintenance",
        "Priority Support",
        "*(State filing fees not included)"
      ]
    }
  ],
  "trademark-search": [
    {
      name: "FEDERAL & STATE SEARCH",
      price: 149,
      description: "",
      features: [
        "Trademark search - The federal search provides any similar names, logos, or slogans that are registered or pending with the USPTO",
        "State Search - The state search does the same for all 50 states",
        "Detailed online report - Identifies any matches with all the information you need to strategize your next step"
      ]
    },
    {
      name: "FEDERAL, STATE & COMMON LAW SEARCH",
      price: 299,
      description: "Includes the information from the Federal, State & Common Law Search, and also includes:",
      features: [
        "Corporate name search - We run a search for all corporate and other business entity names in all 50 states",
        "Corporate Directories - We search the corporate directories for listing of others who might be using your name",
        "Common law - Proprietary internet searches reveal the use of your name that may be protected by common law trademarks",
        "Domain names - We search the most common top level domain names to see if anyone is using your name online"
      ],
      popular: true
    },
    {
      name: "GLOBAL SEARCH",
      price: 499,
      description: "",
      features: [
        "Global search - We search for pending and registered marks in these multi-national jurisdictions:",
        "The European community",
        "World Intellectual Property Organization (WIPO)"
      ]
    }
  ],
  "amazon-brand-registry": [
    {
      name: "Standard",
      price: 99,
      description: "+ USPTO filing fee",
      features: [
        "Amazon Brand Case Review",
        "Amazon Brand Case Filing",
        "100% Satisfaction Guarantee"
      ]
    },
    {
      name: "Diamond",
      price: 149,
      description: "+ USPTO filing fee",
      features: [
        "Amazon Brand Case Review",
        "Amazon Brand Case Preparation",
        "Amazon Brand Case Filing",
        "100% Satisfaction Guarantee",
        "Refusal Risk Meter"
      ],
      popular: true
    },
    {
      name: "Premium",
      price: 199,
      description: "+ USPTO filing fee",
      features: [
        "Amazon Brand Case Review",
        "Amazon Brand Case Preparation",
        "Amazon Brand Case Filing",
        "100% Satisfaction Guarantee",
        "Refusal Risk Meter",
        "Amazon Brand Case Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager"
      ]
    }
  ]
};

export const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Boutique Owner",
    rating: 5,
    text: "Trademark Frontline's team made trademark registration incredibly simple. They guided me through every step and my brand is now fully protected. Highly recommend their services!",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e"
  },
  {
    name: "Michael Chen",
    role: "Tech Startup Founder",
    rating: 5,
    text: "Professional, efficient, and knowledgeable. Trademark Frontline handled our company formation and trademark registration seamlessly. Their expertise saved us countless hours.",
    image: "https://images.unsplash.com/photo-1556157382-97eda2d62296"
  },
  {
    name: "Jennifer Rodriguez",
    role: "Author",
    rating: 5,
    text: "I needed copyright protection for my books and Trademark Frontline delivered exceptional service. Fast, affordable, and thorough. I now have peace of mind knowing my work is protected.",
    image: "https://images.unsplash.com/photo-1581403341630-a6e0b9d2d257"
  },
  {
    name: "David Thompson",
    role: "E-commerce Seller",
    rating: 5,
    text: "The Amazon Brand Registry service was a game-changer for my business. Trademark Frontline handled everything professionally and now my products are fully protected from counterfeiters.",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d"
  },
  {
    name: "Lisa Anderson",
    role: "Restaurant Owner",
    rating: 5,
    text: "From trademark search to final registration, Trademark Frontline provided outstanding service. Their detailed search report gave me confidence before investing in my brand. Worth every penny!",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f"
  }
];

export const faqs = {
  general: [
    {
      question: "What is a trademark and why do I need one?",
      answer: "A trademark protects your brand's name, logo, or slogan from being used by others. It helps secure your business identity, prevents confusion in the marketplace, and builds trust with your customers. Without trademark protection, competitors could use similar names or logos, potentially damaging your reputation and business."
    },
    {
      question: "How long does the trademark registration process take?",
      answer: "The entire process typically takes 8-12 months from filing to approval. We submit your application within 3-5 business days, and the USPTO review process takes 6-10 months. If there are any office actions, we handle them promptly to minimize delays."
    },
    {
      question: "Can I register a trademark for multiple classes?",
      answer: "Yes, trademarks can be registered for multiple classes of goods or services. Each class covers different categories of products or services. Our Standard, Deluxe, and Platinum plans accommodate multiple classes with comprehensive protection."
    },
    {
      question: "What are USPTO fees and are they included in your prices?",
      answer: "USPTO filing fees are government fees charged by the United States Patent and Trademark Office. These fees vary by trademark class (currently $250-$350 per class) and are paid directly to the USPTO. Our service prices cover our professional fees only and do not include government filing fees."
    },
    {
      question: "What happens if my trademark application is rejected?",
      answer: "If the USPTO issues an office action or rejection, our legal team will review it and respond appropriately. Our Deluxe and Platinum packages include office action responses. We'll work diligently to overcome any objections and secure your trademark approval."
    }
  ],
  "trademark-registration": [
    {
      question: "What can I trademark?",
      answer: "You can trademark brand names, logos, slogans, product names, service names, and even certain sounds or colors if they're distinctive to your brand. The mark must be unique and used in commerce to identify your goods or services."
    },
    {
      question: "Do I need a lawyer to register a trademark?",
      answer: "While not legally required, having professional assistance significantly increases your chances of approval. Our experienced team handles thousands of trademark registrations and knows how to navigate USPTO requirements effectively."
    },
    {
      question: "How long does trademark protection last?",
      answer: "A registered trademark lasts 10 years from the registration date. You must file a maintenance document between the 5th and 6th year, and can renew indefinitely every 10 years. We provide renewal reminders to keep your mark protected."
    },
    {
      question: "Can I trademark a name that's already a domain name?",
      answer: "Owning a domain name doesn't grant trademark rights. However, if you're actively using that domain for business, you may be able to trademark the name. We'll conduct a comprehensive search to check availability."
    },
    {
      question: "What's the difference between ™ and ® symbols?",
      answer: "The ™ symbol can be used immediately when you claim trademark rights, even before registration. The ® symbol can only be used after your trademark is officially registered with the USPTO. Using ® without registration is illegal."
    }
  ],
  "copyright-registration": [
    {
      question: "What types of work can be copyrighted?",
      answer: "Copyright protects original works including books, music, art, photographs, software, websites, videos, architectural works, and more. The work must be original and fixed in a tangible form."
    },
    {
      question: "Do I automatically have copyright when I create something?",
      answer: "Yes, copyright exists automatically upon creation. However, registration with the U.S. Copyright Office provides important legal benefits including the ability to sue for infringement and claim statutory damages."
    },
    {
      question: "How long does copyright protection last?",
      answer: "For works created after 1978, copyright generally lasts for the life of the author plus 70 years. For works made for hire or anonymous works, protection lasts 95 years from publication or 120 years from creation, whichever is shorter."
    },
    {
      question: "Can I copyright a name or title?",
      answer: "No, copyright doesn't protect names, titles, slogans, or short phrases. These may be protected by trademark law instead. Copyright protects the creative expression in your work, not just the title."
    },
    {
      question: "What's the difference between copyright and trademark?",
      answer: "Copyright protects original creative works like books and music. Trademark protects brand identifiers like names and logos. Copyright prevents copying of creative content, while trademark prevents brand confusion in the marketplace."
    }
  ],
  "company-formation": [
    {
      question: "What type of business entity should I form?",
      answer: "The best entity depends on your business goals, tax situation, and liability concerns. LLCs offer flexibility and liability protection. Corporations provide strong liability protection and easier fundraising. We'll help you choose the right structure."
    },
    {
      question: "Which state should I form my business in?",
      answer: "Most businesses should form in the state where they primarily operate. Delaware and Nevada are popular for larger companies due to business-friendly laws. We'll advise on the best state for your specific situation."
    },
    {
      question: "What is a registered agent and do I need one?",
      answer: "A registered agent receives legal documents on behalf of your business. All formal business entities must have one. Our Professional and Enterprise packages include registered agent service for your convenience."
    },
    {
      question: "How long does company formation take?",
      answer: "Processing times vary by state, typically 1-3 weeks for standard processing. Some states offer expedited options. We'll handle all paperwork and keep you informed throughout the process."
    },
    {
      question: "What ongoing requirements does my business have?",
      answer: "Most states require annual reports and franchise tax payments. You'll also need to maintain proper records and hold required meetings. Our Enterprise package includes ongoing compliance management."
    }
  ],
  "trademark-search": [
    {
      question: "Why do I need a trademark search?",
      answer: "A comprehensive search identifies potential conflicts before you invest in branding and marketing. It helps avoid costly rebranding, legal disputes, and trademark application rejections."
    },
    {
      question: "Is a trademark search guaranteed?",
      answer: "While we conduct thorough searches across multiple databases, no search can guarantee 100% certainty due to pending applications and unregistered common law marks. However, our comprehensive approach minimizes risk significantly."
    },
    {
      question: "What databases do you search?",
      answer: "Our comprehensive search includes the USPTO federal database, state trademark databases, common law sources, business registries, domain names, and social media handles to provide complete coverage."
    },
    {
      question: "How soon will I get my search results?",
      answer: "Quick Search results are delivered within 24 hours. Comprehensive Search results within 48 hours, and Premium Search with legal opinion within 24 hours due to priority processing."
    },
    {
      question: "What if conflicts are found?",
      answer: "If we find potential conflicts, our report includes detailed analysis and recommendations. You may be able to modify your mark, choose different goods/services classes, or proceed with calculated risk depending on the conflict severity."
    }
  ],
  "amazon-brand-registry": [
    {
      question: "What are the benefits of Amazon Brand Registry?",
      answer: "Brand Registry provides powerful tools to protect and build your brand including enhanced brand content, stores, sponsored ads, automated brand protection, reporting tools, and greater control over product listings."
    },
    {
      question: "Do I need a trademark to enroll in Brand Registry?",
      answer: "Yes, you need an active registered trademark to enroll. The trademark must be a text-based or image-based mark registered with a government trademark office. Our Complete Package includes both trademark and Brand Registry."
    },
    {
      question: "How long does Brand Registry enrollment take?",
      answer: "Once you have an active trademark, Brand Registry enrollment typically takes 1-2 weeks. If you need a trademark first, that process takes 8-12 months, but you can prepare your Brand Registry application while waiting."
    },
    {
      question: "Can I enroll multiple brands?",
      answer: "Yes, you can enroll multiple brands in Brand Registry. Each brand requires its own registered trademark. We offer discounted packages for multiple brand enrollments."
    },
    {
      question: "What if I find counterfeiters after enrolling?",
      answer: "Brand Registry provides tools to report and remove counterfeit listings quickly. Our Premium Protection package includes ongoing monitoring and violation reporting services to keep your brand safe."
    }
  ]
};

export const companyStats = [
  {
    number: "10,000+",
    label: "Trademarks Registered",
    description: "Successfully filed and registered over 10,000 trademarks for businesses across all industries nationwide."
  },
  {
    number: "98%",
    label: "Approval Success Rate",
    description: "Our expert team achieves an exceptional 98% approval rate through meticulous preparation and comprehensive trademark searches."
  },
  {
    number: "50+",
    label: "States Covered",
    description: "Providing trademark registration, company formation, and brand protection services across all 50 United States."
  }
];

export const whyChooseUsPoints = [
  {
    title: "Expert Legal Team",
    description: "Our experienced trademark attorneys and business formation specialists bring decades of combined expertise. We stay current with USPTO regulations and state requirements to ensure your applications are filed correctly the first time."
  },
  {
    title: "Transparent Pricing",
    description: "No hidden fees or surprise charges. Our package pricing is clear and comprehensive, with all costs outlined upfront. You'll know exactly what you're paying for and what's included in your service."
  },
  {
    title: "Dedicated Support",
    description: "From your initial inquiry through final approval and beyond, our dedicated support team is here to help. Get personalized assistance via phone, email, or live chat whenever you need it."
  }
];